<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Facturación</h6>
                </div>
                <div class="col-md-8">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            v-model="searchTerm"
                            :placeholder="
                                this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar...'
                            "
                        />
                    </div>
                </div>
                <div class="col-md-2 ">
                        <argon-button
                        class="mt-0"
                        color="success"
                        fullWidth
                        size="xs"
                        @click="toCreate"
                        >Agregar Nueva</argon-button>
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Código
                            </th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Cliente
                            </th>
                            <th
                                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >
                                NIT Cliente
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Tipo Cliente
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Tipo Factura
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Fecha Emisión
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Subtotal
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Descuentos
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Subtotal
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Impuestos
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Total
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Estado
                            </th>
                            <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(invoice, index) in filteredRows"
                            :key="index"
                        >
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ invoice.full_number }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ invoice.client_name }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ invoice.client_nit }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ invoice.client_type }} <!-- Tipo del cliente (enriquecido de clients) -->
                                </p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">
                                    {{ invoice.invoice_type === 'FACTURA' ? 'Factura' : 'Ticket' }}
                                </p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ $formatDate(invoice.date_issued) }}</p>
                            </td>
                            <td class="text-end">
                                <p class="text-xs font-weight-bold mb-0">{{ $formatCurrency(invoice.sub_total_brut.toFixed(2),currency,symbol) }}</p>
                            </td>
                            <td class="text-end">
                                <p class="text-xs font-weight-bold mb-0">{{ $formatCurrency(invoice.total_discount.toFixed(2),currency,symbol) }}</p>
                            </td>
                            <td class="text-end">
                                <p class="text-xs font-weight-bold mb-0">{{ $formatCurrency(invoice.subtotal.toFixed(2),currency,symbol) }}</p>
                            </td>
                            <td class="text-end">
                                <p class="text-xs font-weight-bold mb-0">{{ $formatCurrency(invoice.total_taxes.toFixed(2),currency,symbol) }}</p>
                            </td>
                            <td class="text-end">
                                <p class="text-xs font-weight-bold mb-0">{{ $formatCurrency(invoice.total.toFixed(2),currency,symbol) }}</p>
                            </td>
                            <td>
                                <span
                                    class="text-xs font-weight-bold mb-0"
                                    :class="invoice.state === 'EMITTED' ? 'text-warning' : invoice.state === 'PAID' ? 'text-success' : 'text-danger'"
                                >
                                    {{ invoice.state === 'EMITTED' ? 'Emitida' : invoice.state === 'PAID' ? 'Pagada' : 'Cancelada' }}
                                </span>
                            </td>
                            <td class="align-middle">
                                <a
                                    :href="'invoices/' + invoice.id"
                                    class="btn bg-success mx-2"
                                    data-toggle="tooltip"
                                    data-original-title="Ver factura"
                                >
                                    <i class="fa fa-eye text-white text-sm opacity-10"></i>
                                </a>

                                <button
                                    v-if="invoice.dte_trace_code"
                                    @click="descargarJSON(invoice)"
                                    class="btn bg-secondary mx-2"
                                    data-toggle="tooltip"
                                    title="Descargar JSON"
                                >
                                    <i class="fa fa-code text-white text-sm opacity-10"></i>
                                </button>

                                <button
                                    v-if="invoice.dte_trace_code"
                                    @click="descargarPDFIndividual(invoice)"
                                    class="btn bg-danger mx-2"
                                    title="Descargar PDF"
                                    :disabled="isProcessing === invoice.id"
                                >
                                    <i v-if="isProcessing !== invoice.id" class="fa fa-file text-white text-sm opacity-10"></i>
                                    <span v-else class="spinner-border spinner-border-sm text-white" role="status"></span>
                                </button>
                                <!-- Puedes agregar más acciones si es necesario -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ArgonButton from "@/components/ArgonButton.vue";
import { useCompanyConfig } from '@/composables/useCompanyConfig';
import { useDTEFiscal } from '@/composables/useDTEFiscal';
export default {
    name: "facturas-table",
    props: {
        clients: {
            type: Array,
            required: true
        },
        invoices: {
            type: Array,
            required: true
        }
    },
    setup(){
        const { companyConfig,isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        // Cargar la configuración cada vez que el componente se monte/cargue
        fetchCompanyConfig();
        return { companyConfig ,isLoadingCiaConfig};
    },
    data() {
        return {
            searchTerm: null,
            isProcessing: null,
            currency:'USD',
            symbol:'$',
            combinedInvoices: []  // Array combinado se calculará aquí

        };
    },
    components: { ArgonButton },
    computed: {
        filteredRows() {
            if (!this.searchTerm) {
                return this.combinedInvoices;
            } else {
                const searchLower = this.searchTerm.toLowerCase();
                return this.combinedInvoices.filter(invoice => {
                    const fullNumber = invoice.full_number.toString().toLowerCase();
                    const clientName = invoice.client_name.toString().toLowerCase();
                    const clientNit = invoice.client_nit.toString().toLowerCase();
                    const clientType = invoice.client_type.toString().toLowerCase();
                    return fullNumber.includes(searchLower) ||
                           clientName.includes(searchLower) ||
                           clientNit.includes(searchLower) ||
                           clientType.includes(searchLower);
                });
            }
        }
    },
    watch: {
        companyConfig(newVal){
            this.currency=newVal.currency_code;
            this.symbol=newVal.currency_symbol;
        },
        // Observar cambios en clients o invoices para recalcular la combinación
        clients: {
            handler() {
                this.combineData();
            },
            deep: true
        },
        invoices: {
            handler() {
                this.combineData();
            },
            deep: true
        }
    },
    mounted() {
        this.combineData();  // Calcular la combinación inicial al montar el componente
    },
    methods: {
        combineData() {
            // Función para combinar clients e invoices por client_id
            // Enriquecemos cada invoice con el objeto client completo y agregamos campos derivados como client_type
            this.combinedInvoices = this.invoices.map(invoice => {
                const client = this.clients.find(c => c.id === invoice.client_id);
                return {
                    ...invoice,  // Copia todos los campos del invoice
                    client: client || null,  // Objeto client completo (para uso futuro, ej. email, phone)
                    client_type: client ? client.type : 'DESCONOCIDO'  // Campo derivado para la tabla (NATURAL/JURIDICA)
                };
            }).filter(invoice => invoice.client !== null);  // Opcional: filtrar facturas sin client matching
        },
        toCreate() {
            this.$router.push('/invoices/create');  // Ajustado para nueva factura
        },

        async descargarPDFIndividual(inv) {
            this.isProcessing = inv.id;

            try {
                // 1. Obtener detalles de la factura (Lineas)
                const invoiceDetails = await this.getInvoiceDetails(inv.id);

                // El objeto cliente ya lo tenemos gracias a tu método combineData()
                const clientData = inv.client || {};

                // 2. Mapear al formato que requiere el PDF (idéntico a tu lógica masiva)
                const facturaData = {
                    header: {
                        ...inv,
                        client_name: inv.client_name || clientData.name,
                        client_nit: inv.client_nit || clientData.nit,
                        client_nrc: inv.client_nrc || clientData.nrc || 'N/A',
                        client_address: clientData.fiscal_address || clientData.address || 'Sin dirección',
                        client_phone: clientData.phone || 'N/A',
                        client_email: clientData.email || 'N/A',
                        client_department:clientData.department,
                        client_municipality: clientData.municipality,
                        client_activity_code: clientData.activity_code || '99999',
                        client_activity_desc: clientData.activity_desc || 'Venta al consumidor',
                        client_document_type: clientData.document_type || '36',
                        // Formateo de números
                        subtotal: parseFloat(inv.subtotal),
                        total_taxes: parseFloat(inv.total_taxes),
                        total: parseFloat(inv.total),
                        sub_total_brut: parseFloat(inv.sub_total_brut || inv.subtotal),
                        retention_amount: parseFloat(inv.retention_amount || 0)
                    },
                    lines: invoiceDetails.map(line => ({
                        ...line,
                        quantity: parseFloat(line.quantity),
                        unit_price: parseFloat(line.unit_price),
                        sub_total_brut: parseFloat(line.sub_total_brut),
                        line_total: parseFloat(line.line_total)
                    }))
                };

                // 3. Generar el PDF
                // false = No es reimpresión (sin marca de agua opcional)
                // true = Es exportación (para que no intente enviar correos)
                await useDTEFiscal(facturaData, this.companyConfig, false, true);

            } catch (error) {
                console.error("Error generando PDF:", error);
                this.$swal('Error', 'No se pudo generar el PDF de la factura.', 'error');
            } finally {
                this.isProcessing = null;
            }
        },

        /**
         * Obtener líneas de factura desde el API
         */
        async getInvoiceDetails(invoiceId) {
            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            try {
                const response = await axios.get(`${apiURL}invoice_lines?invoice_id=${invoiceId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                return response.data;
            } catch (e) {
                console.error("Error items:", e);
                return [];
            }
        },
        async descargarJSON(invoice) {
            try {
                const url = this.$store.state.servURL + invoice.dte_trace_code + '.json';

                // 1. Obtener la data del servidor
                const response = await axios.get(url, { responseType: 'blob' });

                // 2. Crear un objeto URL para el Blob
                // Importante: No agregamos \ufeff para evitar el error de esquema de Hacienda
                const blob = new Blob([response.data], { type: 'application/json' });
                const link = document.createElement('a');
                const objectUrl = window.URL.createObjectURL(blob);

                // 3. Configurar el nombre del archivo (usando el código de generación o número control)
                link.href = objectUrl;
                link.download = `${invoice.dte_trace_code}.json`;

                // 4. Disparar la descarga y limpiar
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(objectUrl);

            } catch (error) {
                console.error("Error al descargar el JSON:", error);
                this.$swal('Error', 'No se pudo descargar el archivo JSON del servidor.', 'error');
            }
        }
    },
};
</script>